import {ChangeDetectionStrategy, Component, Input} from "@angular/core";
import {FUIAbstractLabel} from "../../../labels/abstract-label";

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "fui-input-label",
    styleUrls: ["./input-label.component.scss"],
    templateUrl: "./input-label.component.html",
    standalone: false
})
export class FUIInputLabelComponent extends FUIAbstractLabel {
}
